webpackJsonp([12],{

/***/ "LOGg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match__ = __webpack_require__("sw5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact_router_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact_router_match__);




var _ref = Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
  'div',
  { 'class': 'wrap wrap--thin lift-children' },
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'h1',
    { 'class': 'mb20' },
    'About JournalBook'
  ),
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'JournalBook is a private, offline-first personal journal.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'A journal is a personal thing, so JournalBook strives to be the most private online journal out there.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'Your notes are ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'strong',
        null,
        'only'
      ),
      ' stored on your device, they\'re never even sent to a server. You don\'t even need to sign-in to use it! It works offline, so you can reflect upon your day on the slow train journey home.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'This does mean there\'s ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'strong',
        null,
        'no online backup'
      ),
      ' of your entries should you lose your phone/computer or anything go wrong on our side. However, you can import and export your data from',
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        __WEBPACK_IMPORTED_MODULE_1_preact_router_match__["Link"],
        { href: '/settings/' },
        'the settings area'
      ),
      ' and we\'d encourage you to do that from time to time!.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'As well as traditional written entries, you can use JournalBook to track sleep, medicines, anxiety, exercise, habits, or just about anything else you fancy.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'It\'s quick and is developed',
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        { href: 'https://github.com/trys/JournalBook' },
        'in the open'
      ),
      '. You can even add it to your homescreen as an app.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      null,
      'If you do have any issues, or want to suggest a new feature, please',
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        { href: 'https://twitter.com/trysmudford/' },
        'tweet me'
      ),
      ' or raise an',
      ' ',
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'a',
        { href: 'https://github.com/trys/JournalBook/' },
        'issue on GitHub'
      ),
      '.'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
      'p',
      { className: 'mb20' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
        'small',
        null,
        'Created by ',
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(
          'a',
          { href: 'https://trysmudford.com' },
          'Trys'
        )
      )
    )
  )
);

var NotFound = function NotFound() {
  return _ref;
};

/* harmony default export */ __webpack_exports__["default"] = (NotFound);

/***/ })

});


// WEBPACK FOOTER //
// route-about.chunk.25b42.js